<script>
import setup from "../../setup"
export default {
    render() {
        return this.$scopedSlots.default({
            accounts: setup.current_app.accounts,
            select: setup.guard.redirectToAccount,
            professional: setup.user.default_professional
        });
    }
};
</script>

